import { PaletteOptions } from "@mui/material/styles";
import {
  CHARCOAL,
  GRAPHITE_GREY,
  QUARTZ_WHITE,
  PEAK4_BLUE,
  SUMMIT_GREEN,
  PERFORM_ORANGE,
  RECOVER_PINK,
  FUEL_INDIGO,
} from "./brandColors";

// PEAK4 2026 brand palette.
// Primary: PEAK4 Blue. Secondary: Summit Green.
// Light surfaces use Quartz White; dark surfaces use Charcoal / Graphite Grey.
export const lightPalette: PaletteOptions = {
  mode: "light",
  primary: {
    main: PEAK4_BLUE,
  },
  secondary: {
    main: SUMMIT_GREEN,
  },
  warning: {
    main: PERFORM_ORANGE,
  },
  error: {
    main: RECOVER_PINK,
  },
  info: {
    main: FUEL_INDIGO,
  },
  success: {
    main: SUMMIT_GREEN,
  },
  background: {
    default: QUARTZ_WHITE,
    paper: "#FFFFFF",
  },
  text: {
    primary: CHARCOAL,
  },
};

export const darkPalette: PaletteOptions = {
  mode: "dark",
  primary: {
    main: PEAK4_BLUE,
  },
  secondary: {
    main: SUMMIT_GREEN,
  },
  warning: {
    main: PERFORM_ORANGE,
  },
  error: {
    main: RECOVER_PINK,
  },
  info: {
    main: FUEL_INDIGO,
  },
  success: {
    main: SUMMIT_GREEN,
  },
  background: {
    default: CHARCOAL,
    paper: GRAPHITE_GREY,
  },
  text: {
    primary: QUARTZ_WHITE,
  },
};
